import React, { useEffect } from "react"
import { Switch, Route, useLocation } from "react-router-dom"

import Appointment from "./pages/Appointment/Appointment"
import LandingPage from "./pages/LandingPage/LandingPage"
import VehicleDetails from "./pages/VehicleDetails/VehicleDetails"
import YourVehicle from "./pages/YourVehicle/YourVehicle"
import YourDetails from "./pages/YourDetails/YourDetails"
import { ErrorPage } from "./pages/Error/Error"
import CouldntFindVehicle from "./pages/NoVehicle/CouldntFindVehicle"
import AppointmentConfirmation from "./pages/AppointmentConfirmation/AppointmentConfirmation"
import CouldntFindVehicleConfirmation from "./pages/NoVehicleConfirmation/CouldntFindVehicleConfirmation"
import ValuationsLimit from "./pages/ValuationsLimit/ValuationsLimit"
import CallRequestedConfirmation from "./pages/CallRequestedConfirmation/CallRequestedConfirmation"
import ValuationNotProcessed from "./pages/ValuationNotProcessed/ValuationNotProcessed"

const Routes: React.FC = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return (
    <Switch>
      <Route exact path="/" component={LandingPage} />
      <Route path="/valuation-given" component={Appointment} />
      <Route path="/vehicle-details" component={VehicleDetails} />
      <Route path="/confirm-vehicle" component={YourVehicle} />
      <Route path="/contact-details" component={YourDetails} />
      <Route path="/call-requested" component={CallRequestedConfirmation} />
      <Route path="/valuations-exceeded" component={ValuationsLimit} />
      <Route path="/vehicle-not-found" component={CouldntFindVehicle} />
      <Route
        path="/vehicle-not-found-thank-you"
        component={CouldntFindVehicleConfirmation}
      />
      <Route path="/appointment-booked" component={AppointmentConfirmation} />
      <Route path="/valuation-request-not-processed" component={ValuationNotProcessed} />
      <Route path="/error" component={ErrorPage} />
      <Route path="*" component={ErrorPage} />
    </Switch>
  )
}

export default Routes
